import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { setAdmin } from '@/redux/actions';

const SOCKET_EVENTS_BY_HTTP = {
	CREATE: 'admin/POST',
	UPDATE: 'admin/PATCH',
};

const AdminSubscriptions = props => {
	const { socket, createAdmin, updateAdmin } = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToAdmin = () => {
		console.log('⚡️ AdminSubscriptions Mounted ⚡️');
		socket.emit('admin/SUBSCRIBE');
	};

	const unsubscribeToAdmin = () => {
		console.log(`🚶‍♂️ AdminSubscriptions Unmounted 🚶‍♂️`);
		socket.emit('admin/UNSUBSCRIBE');
	};

	const listenForCreatedAdmin = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating admin', error);
			else {
				createAdmin(data);
				displayMessage('Admin created');
			}
		});

	const listenForUpdatedAdmin = () =>
		socket.on(SOCKET_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating admin', error);
			else {
				updateAdmin(data);
				displayMessage('Admin updated');
			}
		});

	const listeners = () => [listenForCreatedAdmin, listenForUpdatedAdmin];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToAdmin}
				unsub={unsubscribeToAdmin}
				listeners={listeners()}
				routes={Object.values(SOCKET_EVENTS_BY_HTTP)}
				from="admin"
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws }) => ({
	socket: ws.socket,
});

const mdp = dispatch => ({
	updateAdmin: admin => dispatch(setAdmin(admin)),
	createAdmin: admin => dispatch(setAdmin(admin)),
});

export default connect(msp, mdp)(AdminSubscriptions);
